import React from 'react';
import logoShop from '../../images/logo-utees-shop.svg';
import DesignPreview from '../DesignPreview/DesignPreview';
import './ModalPageThree.css';

function ModalPageThree(props) {
  // Use the preview URL passed from the parent component
  const previewUrl = props.previewUrl;

  const formatDate = dateString => {
    if (!dateString) return 'Not specified';
    // Parse the date string and add time to avoid timezone issues
    // If the date string is just YYYY-MM-DD, append time to treat as local
    const localDateString = dateString.includes('T')
      ? dateString
      : `${dateString}T00:00:00`;
    const date = new Date(localDateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  };

  const titleize = str => {
    if (!str) return str;
    return str
      .toLowerCase()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  const copyToClipboard = () => {
    if (previewUrl) {
      navigator.clipboard
        .writeText(previewUrl)
        .then(() => {
          alert('Preview link copied to clipboard!');
        })
        .catch(err => {
          console.error('Failed to copy:', err);
        });
    }
  };
  return (
    <section className="stack stack--large centered stretch phm" id="step-4">
      <div className="stack">
        <h1 className="heading-base heading-large heading-heavy heading-cofo">
          Thank you!
        </h1>
        <p className="medium medium--res">
          {props.formData.isStudent ? (
            <em>
              We are matching you with a{' '}
              <span className="tooltip-item">
                <span className="underline">Campus Manager™</span>{' '}
                <span className="tooltip tooltip--top tooltip--large tooltip--blue">
                  Our Campus Managers™ are experienced order facilitators who
                  help bring your ideas to life!
                </span>
              </span>{' '}
              and they will be reaching out to you soon.
            </em>
          ) : (
            <em>
              We are matching you with an Account Executive and they will be
              reaching out to you soon.
            </em>
          )}
        </p>

        {/* Preview Link Section - Moved to top and de-emphasized */}
        {previewUrl && (
          <div className="preview-link-section-top">
            <p className="small centered mbn">
              {props.formData.designCustomization
                ? 'Share your design with others!'
                : 'Share your quote details with others!'}
            </p>
            <div className="mts">
              <div className="preview-link-box">
                <input
                  type="text"
                  value={previewUrl}
                  readOnly
                  className="preview-link-input"
                  onClick={e => e.target.select()}
                />
                <button
                  className="button button--small"
                  onClick={copyToClipboard}
                >
                  Copy Link
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Two Column Layout - Design Preview and Order Details */}
        <div className="modal-page-three-columns">
          {/* Left Column - Design Preview */}
          <div className="modal-page-three-left">
            {props.formData.product ||
            props.formData.design ||
            props.formData.designCustomization ? (
              <DesignPreview
                designData={{
                  product: props.formData.product,
                  product_color: props.formData.productColor,
                  design: props.formData.design,
                  design_customization: props.formData.designCustomization,
                }}
                hideCustomerDetails={true}
              />
            ) : (
              <div className="no-preview-message">
                <p>No product or designs selected</p>
              </div>
            )}
          </div>

          {/* Right Column - Customer & Order Details */}
          <div className="modal-page-three-right">
            <div className="order-details-box">
              {/* Customer Information */}
              <div className="detail-section">
                <h4 className="detail-section-title">Customer Information</h4>
                <div className="detail-row">
                  <span className="detail-label">Name:</span>
                  <span className="detail-value">{props.formData.name}</span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">Email:</span>
                  <span className="detail-value">{props.formData.email}</span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">Phone:</span>
                  <span className="detail-value">
                    {props.formData.phoneNumber}
                  </span>
                </div>
                {props.formData.isStudent && (
                  <div className="detail-row">
                    <span className="detail-label">School:</span>
                    <span className="detail-value">
                      {props.formData.school}
                    </span>
                  </div>
                )}
                {props.formData.isStudent && props.formData.organization && (
                  <div className="detail-row">
                    <span className="detail-label">Organization:</span>
                    <span className="detail-value">
                      {props.formData.organization}
                    </span>
                  </div>
                )}
                {!props.formData.isStudent && (
                  <div className="detail-row">
                    <span className="detail-label">Business:</span>
                    <span className="detail-value">
                      {props.formData.businessName || 'N/A'}
                    </span>
                  </div>
                )}
                {props.formData.eventName && (
                  <div className="detail-row">
                    <span className="detail-label">Event:</span>
                    <span className="detail-value">
                      {props.formData.eventName}
                    </span>
                  </div>
                )}
                {props.formData.orderNotes && (
                  <div className="detail-row">
                    <span className="detail-label">Notes:</span>
                    <span className="detail-value">
                      {props.formData.orderNotes}
                    </span>
                  </div>
                )}
              </div>

              {/* Order Information */}
              <div className="detail-section">
                <h4 className="detail-section-title">Order Information</h4>
                {props.formData.product ? (
                  <>
                    <div className="detail-row">
                      <span className="detail-label">Product:</span>
                      <span className="detail-value">
                        {props.formData.product.brandName}{' '}
                        {props.formData.product.style}{' '}
                        {props.formData.product.name}
                      </span>
                    </div>
                    {props.formData.productColor &&
                      props.formData.productColor.name !== 'Default' && (
                        <div className="detail-row">
                          <span className="detail-label">Color:</span>
                          <span className="detail-value">
                            {titleize(props.formData.productColor.name)}
                          </span>
                        </div>
                      )}
                  </>
                ) : (
                  <div className="detail-row">
                    <span className="detail-label">Product:</span>
                    <span className="detail-value">No product selected</span>
                  </div>
                )}
                <div className="detail-row">
                  <span className="detail-label">Quantity:</span>
                  <span className="detail-value">
                    {props.formData.quantity || '-'}
                  </span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">Budget:</span>
                  <span className="detail-value">
                    {props.formData.budget ? `$${props.formData.budget}` : '-'}
                  </span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">Delivery Date:</span>
                  <span className="detail-value">
                    {formatDate(props.formData.deliveryDate) || 'Not specified'}
                  </span>
                </div>
                {props.formData.designNotes && (
                  <div className="detail-row">
                    <span className="detail-label">Design Notes:</span>
                    <span className="detail-value">
                      {props.formData.designNotes}
                    </span>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="capped row row-centered2">
          <div className="col-6--m">
            <p className="phs">
              <small>
                Shop single-piece apparel for your organization on the
              </small>
            </p>
            <h2>
              <img src={logoShop} alt="Logo for the University Tees Shop" />
              <span className="is-hidden-visually">University Tees Shop</span>
            </h2>
            <a
              href="https://shop.universitytees.com"
              className="button"
              target="_blank"
              rel="noopener noreferrer"
            >
              Shop Now
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ModalPageThree;
